import React from 'react';
import { DateTimeFormatter } from '@nile/components';
import { Button, Heading, TextStyle } from '@superops/ui-design-system';
import { FormattedMessage, injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { SVGIcon } from '@superops/super-icons';
import { HeaderContainer } from './styles';
import { getNonAuthToken } from '@nile/graphql';

const SharedReportHeader = (props) => {
  const { data } = props;

  //hide export pdf button for external user
  const hideExportPDFBtn = getNonAuthToken() ? true : false;

  return (
    <HeaderContainer>
      <div className="fx fcol f11">
        {data?.reportName ? (
          <Heading element="h1" weight="Bold">
            {data.reportName}
          </Heading>
        ) : (
          <TextStyle variation="subdued">NA</TextStyle>
        )}
      </div>
      <div className="flex f11 jend">
        <div className="flex actr mr-20">
          {data?.startDateTime && data?.endDateTime && (
            <>
              <DateTimeFormatter type="dateTime" date={data?.startDateTime} />
              <span> - </span>
              <DateTimeFormatter type="dateTime" date={data?.endDateTime} />
            </>
          )}
        </div>
        <div className="mr8">
          {!hideExportPDFBtn && (
            <Button
              url={`#/export/sharedreport/${data.id}`}
              external
              icon={<SVGIcon name="Download" />}
            >
              <FormattedMessage id="reports.report.header.download.button" />
            </Button>
          )}
        </div>
      </div>
    </HeaderContainer>
  );
};

export default withRouter(injectIntl(SharedReportHeader));
